import { render, staticRenderFns } from "./TableViewModeToggle.vue?vue&type=template&id=86ea20e6"
import script from "./TableViewModeToggle.vue?vue&type=script&lang=js"
export * from "./TableViewModeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports